import { Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";

export const DeleteButton = styled(Button)`
  margin: 32px 0;
`;

export const StatusSettingBodyText = styled(Typography.BodyText)`
  color: var(--section-slate-color, var(--slate));
`;
